import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { showCustomToast, CustomToastContainer } from './CustomToast';
import { useAuth } from '../context/auth';

const UlearningMaterial = () => {
  const [videoCarousels, setVideoCarousels] = useState([]);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [auth] = useAuth();

  // Function to extract video embed URL
  const getEmbedUrl = (url) => {
    try{
    // YouTube URL handling
    if (url.includes('youtube.com/watch?v=')) {
      const videoId = url.split('v=')[1].split('&')[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    
    // YouTube short URL handling
    if (url.includes('youtu.be/')) {
      const videoId = url.split('youtu.be/')[1];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    
    // Vimeo URL handling
    if (url.includes('vimeo.com/')) {
      const videoId = url.split('vimeo.com/')[1].split('?')[0];
      return `https://player.vimeo.com/video/${videoId}`;
    }
     // Direct video file handling
     if (url.match(/\.(mp4|webm|ogg)$/i)) {
      return url;
    }
    return url;
  }catch(err){
    console.error('Error processing video URL:', error);
    return null;
  }
  };

  // Fetch video carousels on component mount
  useEffect(() => {
    const fetchVideoCarousels = async () => {
      try {
        const response = await axios.get('https://api.makeeasydocuments.com/api/videoroutes/getAllVideoCarousels');
        setVideoCarousels(response.data.carousels);
        console.log("Video Carousels:", response.data.carousels);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching video carousels:', error);
        setError('Failed to fetch video carousels.');
        setLoading(false);
      }
    };
    fetchVideoCarousels();
  }, []);

  // Open video modal
  const openVideoModal = (video) => {
    setSelectedVideo({
      name: video.name,
      url: getEmbedUrl(video.url)
    });
    setShowVideoModal(true);
  };


  // Enhanced Iframe Component
const VideoPlayer = ({ url, name }) => {
  const [error, setError] = useState(false);
  const embedUrl = getEmbedUrl(url);

  const handleError = (e) => {
    console.error('Video embed error:', e);
    setError(true);
  };

  if (error || !embedUrl) {
    return (
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
        <strong className="font-bold">Video Playback Error</strong>
        <span className="block sm:inline">Unable to load video. Please check the URL.</span>
      </div>
    );
  }

  return (
    <iframe
      src={embedUrl}
      title={name}
      className="w-full h-full"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      onError={handleError}
    />
  );
};

  // Video Modal Component
  const VideoModal = () => {
    if (!selectedVideo) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg max-w-2xl w-full">
          <h2 className="text-xl font-bold mb-4">{selectedVideo.name}</h2>
          <div className="aspect-video">
            <iframe
              src={selectedVideo.url}
              title={selectedVideo.name}
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <button 
            onClick={() => setShowVideoModal(false)}
            className="mt-4 w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
          >
            Close
          </button>
        </div>
      </div>
    );
  };

  // Render video carousels
  const renderVideoCarousels = () => {
    if (loading) return <p className="text-center text-gray-600">Loading videos...</p>;
    if (error) return <p className="text-center text-red-500">{error}</p>;
    if (videoCarousels.length === 0) return <p className="text-center text-gray-600">No videos found</p>;

    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {videoCarousels.map((carousel) => (
          <div 
            key={carousel._id} 
            className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer hover:shadow-xl transition-shadow duration-300"
            onClick={() => openVideoModal(carousel)}
          >
            <div className="p-4">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">{carousel.name}</h3>
              <p className="text-sm text-gray-600 truncate">{carousel.url}</p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="pt-1 sm:px-3 bg-slate-100 min-h-screen">
      <CustomToastContainer />
      
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 text-center">Learning Materials</h1>
        
        {renderVideoCarousels()}
        
        {/* Video Modal */}
        {showVideoModal && <VideoModal />}
      </div>
    </div>
  );
};

export default UlearningMaterial;